import { UIConfig } from "../types/UIConfig";

export const getPrimaryColor = (
  config: UIConfig,
  opacity: number = 1
): string => {
  if (config.primaryColor) {
    return `hsla(${config.primaryColor.hue}, ${config.primaryColor.saturation}, ${config.primaryColor.lightness}, ${opacity})`;
  }

  return `hsla(182, 100%, 34%, ${opacity})`;
};

export const getSecondaryColor = (config: UIConfig): string => {
  if (config.secondaryColor) {
    return `hsl(${config.secondaryColor.hue}, ${config.secondaryColor.saturation}, ${config.secondaryColor.lightness})`;
  }

  return "hsla(234, 24%, 39%, 1)";
};

export function hexToHsl(hex: string): string | undefined {
  const cleanHex = hex.replace(/^#/, "");

  const r = parseInt(cleanHex.substring(0, 2), 16) / 255;
  const g = parseInt(cleanHex.substring(2, 4), 16) / 255;
  const b = parseInt(cleanHex.substring(4, 6), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const delta = max - min;

  let h = 0;
  let s = 0;
  const l = (max + min) / 2;

  if (delta !== 0) {
    s = l > 0.5 ? delta / (2 - max - min) : delta / (max + min);

    switch (max) {
      case r:
        h = ((g - b) / delta + (g < b ? 6 : 0)) / 6;
        break;
      case g:
        h = ((b - r) / delta + 2) / 6;
        break;
      case b:
        h = ((r - g) / delta + 4) / 6;
        break;
    }
  }

  if (isNaN(h) || isNaN(s) || isNaN(l)) {
    console.error("Invalid hex: ", hex);
    return undefined;
  }

  return `hsla(${Math.round(h * 360)}, ${Math.round(s * 100)}%, ${Math.round(
    l * 100
  )}%, 1)`;
}
